import { Component, HostListener } from '@angular/core';
import { Observable, Subject, concatMap, debounceTime, distinctUntilChanged, tap} from 'rxjs';
import { ItsmService } from '../../services/itsm.service';
import { SupportCaseSearchCriteria } from '../../model/searchCriteria';
import { Router } from '@angular/router';
import { Case } from '../../model/itsm';

@Component({
  selector: 'app-search-bar',
  templateUrl: './search-bar.component.html',
  styleUrl: './search-bar.component.scss',
})
export class SearchBarComponent {

  private searchTerms = new Subject<string>();
  private escapeKey = 'Escape';
  public inputValue: string = '';
  public results$: Observable<Case[]>;
  public searchCanvas = false;
  public resultsLoading = false;
  public randomValue = 0;

  // Allow to close search window using escape
  @HostListener('window:keyup', ['$event'])
  keyEvent(event: KeyboardEvent) {
    if(event.key === this.escapeKey) {
      this.closeSearchPanel();
    }
  }
  
  constructor(private itsmService: ItsmService, private router: Router) {
    this.randomValue = Math.floor(Math.random() * 1000); 
    this.results$ = this.searchTerms.pipe(
      debounceTime(1000),
      tap(() => this.resultsLoading = true),
      distinctUntilChanged(),
      concatMap((term: string) => this.search(term)),
    //  scan((acc, curr) => [...acc, ...curr], []) // If you want accumulate results instead of replacing
    );
    this.results$.subscribe( () => this.resultsLoading = false);
  }

  private search(term: string): Promise<Case[]> {
    if (!term.trim()) {
      // prevent to skip these step in the subscribe answer
      this.resultsLoading = false;
      // if not search term, return empty observable.
      return Promise.resolve([]);
    }
    let searchCriteria = new SupportCaseSearchCriteria();
    searchCriteria.likeSearch = term;
    return this.itsmService.likeCaseSearch(searchCriteria);
  }

  public focusSearch() {
    document.getElementById('inputSearch').focus();
  }

  // Push a search term into the observable stream.
  public searchInput(term: string): void {
    this.searchCanvas = true;
    this.searchTerms.next(term);
  }

  public goToCase(caseId: string) {
    this.router.navigateByUrl(`/support/view/${caseId}`);
    this.closeSearchPanel();
  }

  public closeSearchPanel() {
    this.searchCanvas = false;
    this.inputValue = '';
    this.searchTerms.next('');
  }

}
